var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h20v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10a9 9 0 10-10.406 8.89v-6.288H6.309V10h2.285V8.017c0-2.255 1.343-3.501 3.4-3.501.984 0 2.014.175 2.014.175v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406V10h2.496l-.399 2.602h-2.097v6.289C15.71 18.216 19 14.492 19 10z",
    fill: "#1877F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.503 12.602l.4-2.602h-2.497V8.312c0-.712.349-1.406 1.467-1.406h1.135V4.691s-1.03-.175-2.015-.175c-2.056 0-3.4 1.246-3.4 3.501V10H6.31v2.602h2.285v6.289a9.067 9.067 0 002.812 0V12.6h2.097z",
    fill: "#fff"
  })));
}
export default SvgFacebook;